import { createI18n } from 'vue-i18n';
import en from './en.js';
import de from './de.js';

const storedLocale = localStorage.getItem('locale') || 'en';
const messages = { en, de }

export const i18n = createI18n({
    legacy: false,
    locale: storedLocale,
    fallbackLocale: 'en',
    warnHtmlMessage: false,
    messages
})